import { render, staticRenderFns } from "./lang-select.vue?vue&type=template&id=03c8af30&lang=pug&"
import script from "./lang-select.vue?vue&type=script&lang=js&"
export * from "./lang-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports